export default "__VITE_ASSET__Dk5sUzwn__"